import { get, post, put, del, verify } from './http'

// 获取登录二维码令牌
export const apiQrticket = params => get('/v1/web/login/qrticket', params);

// 轮训查询令牌
// 9000 等待小程序授权，9001 令牌失效或不存在
export const apiVerify = params => verify('/v1/web/login/verify', params);


// 查询反馈
//page=0&size=10
export const apiFeedback = params => get('/v1/web/feedback', params);

// 活动列表
export const apiActivity = params => get('/v1/web/activity', params);

//活动详情
export const apiActivityDetail = params => get('/v1/web/activity/' + params.uuid);

// 快捷词库
export const apiGetWords = params => get('/v1/web/words', params);
// POST
// { word:"string" }
export const apiAddWords = params => post('/v1/web/words', params);
// 删除
export const apiDelWords = params => del('/v1/web/words/' + params.id);


// 用户列表
export const apiUser = params => get('/v1/web/user', params);
export const apiSetAdmin = params => put('/v1/web/user/' + params.uuid + '/admin', params);
export const apiSetStaff = params => put('/v1/web/user/' + params.uuid + '/staff', params);
export const apiSetUser = params => put('/v1/web/user/' + params.uuid + '/default', params);


// 获取杯测表
// export const apiTableDetail = params => get('/v1/activity/table/'+ params.tableId)

// 全部字典
// GET /constant/occupations 职业字典
// GET /constant/sexes 性别字典
// GET /constant/deep 烘焙程度字典
// GET /constant/methods 处理方式字典
// GET /activity/status 活动状态字典
// GET /activity/category 活动类型字典
export const apiConstant = params => get('/v1/constant', params);

// 小程序接口
// 咖啡豆列表
export const apiBeansList = params => get('/v1/beans', params);
// 创建咖啡豆
export const apiBeansCreate = params => post('/v1/beans/create', params);
// 编辑咖啡豆
export const apiBeansEdit = params => put('/v1/beans/'+params.uuid, params);
// 删除咖啡豆
export const apiBeansDelete = params => del('/v1/beans/'+params.uuid);

// 例子
export const apiAddress = params => post('api/v1/users/my_address/address_edit_before', params);
// import { apiAddress } from '@/request/api';// 导入我们的api接口
// export default {        
//     name: 'Address',    
//     created () {
//         this.onLoad();
//     },
//     methods: {            
//         // 获取数据            
//         onLoad() {
//             // 调用api接口，并且提供了两个参数                
//             apiAddress({                    
//                 type: 0,                    
//                 sort: 1                
//             }).then(res => {
//                 // 获取数据成功后的其他操作
//                 ………………                
//             })            
//         }        
//     }
// }